.screen {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background-color: #14241a;
  background-image: var(--login-bg);
  background-size: cover;
  background-position: center;
  font-family: var(--token-font-body);
  color: var(--token-text-primary);
  overflow: hidden;
}

.tint {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    120% 90% at 50% 30%,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(0, 0, 0, 0.45) 100%
  );
  pointer-events: none;
}

.stack {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  max-width: 520px;
  width: min(92vw, 520px);
}

.mascot {
  width: clamp(110px, 16vw, 160px);
  height: auto;
  filter: drop-shadow(0 18px 28px rgba(0, 0, 0, 0.45));
  /* Sit flush on top of the glass card. PNGs are bottom-aligned to the
   * mascot's feet, so 0 margin keeps the silhouette consistently planted
   * across all six themes. */
  margin-bottom: 0;
  user-select: none;
  -webkit-user-drag: none;
}

.card {
  position: relative;
  width: 100%;
  padding: 36px 32px 28px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(22px) saturate(160%);
  -webkit-backdrop-filter: blur(22px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow:
    0 30px 60px -20px rgba(8, 18, 12, 0.55),
    0 12px 24px rgba(8, 18, 12, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.6),
    inset 0 -1px 0 rgba(8, 18, 12, 0.08);
  color: #f7faf6;
  text-align: center;
}

.title {
  margin: 0 0 6px;
  font-family: var(--token-font-display);
  font-size: clamp(44px, 6vw, 64px);
  line-height: 1;
  letter-spacing: 0.5px;
  color: #fefdf6;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
}

.tagline {
  margin: 0 0 18px;
  font-family: var(--token-font-ui);
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  letter-spacing: 0.2px;
}

.bullets {
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  font-family: var(--token-font-body);
  font-size: 15px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.92);
}

.bullets li {
  position: relative;
  padding-left: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bullets li::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 0.55em;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--token-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 25%, transparent);
}

.signInButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 14px 22px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.92);
  color: #1f2933;
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition:
    transform 120ms ease,
    background 120ms ease,
    box-shadow 120ms ease;
  box-shadow:
    0 10px 24px -8px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.signInButton:hover:not(:disabled) {
  background: #ffffff;
  transform: translateY(-1px);
}

.signInButton:active:not(:disabled) {
  transform: translateY(0);
}

.signInButton:disabled {
  cursor: progress;
  opacity: 0.7;
}

.logo {
  flex-shrink: 0;
}

.fineprint {
  margin: 18px 0 0;
  font-family: var(--token-font-ui);
  font-size: 12px;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.45;
}

@media (max-width: 480px) {
  .card {
    padding: 28px 22px 22px;
    border-radius: 24px;
  }
  .mascot {
    margin-bottom: -22px;
  }
}
